import React from 'react';
import { Navigate } from 'react-router-dom';

export const PrivateRoutes = ({ children, isLoggedIn, statusUser }) => {
  if (!isLoggedIn || statusUser !== 'active') {
    return <Navigate to='/auth/login' />;
  }
  return children;
};
